const GlossaryPage = () => import('./GlossaryPage.vue');

export default [
  {
    path: '/glossary',
    name: 'glossary',
    component: GlossaryPage
  }
];
